import React from 'react';

import ReportPanel from '../SettingsModal/ReportPanel';
import CreateWidget from '../SettingsModal/CreateWidget';
import CompetitionPanel from '../SettingsModal/CompetitionPanel';
import SlideSettingsModal from '../SlideSettingsModal/SlideSettings';

const TabContent = (props) => {
    const panels = {
        SlideSettingsModal,
        ReportPanel,
        CreateWidget,
        CompetitionPanel,
    };

    const ThisPanel = panels[props.renderClass];
    return (
        <div>
            <ThisPanel {... props} />
        </div>
    );
};

TabContent.propTypes = {
    active: React.PropTypes.bool,
    renderClass: React.PropTypes.string,
};

export default TabContent;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsTab/TabContent.jsx
 **/